import { render, staticRenderFns } from "./examen_vue.vue?vue&type=template&id=67e27c10&scoped=true&"
import script from "./examen_vue.vue?vue&type=script&lang=js&"
export * from "./examen_vue.vue?vue&type=script&lang=js&"
import style0 from "./examen_vue.vue?vue&type=style&index=0&id=67e27c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e27c10",
  null
  
)

export default component.exports